import type { GamesByClubs, PageData } from '@swf/core/types/Poker';
import { ClubPlayerRole, UserClubRole } from '@swf/core/types/Poker';

import {
  TXTCLI_Admin,
  TXTCLI_Guest,
  TXTCLI_Manager,
  TXTCLI_Member,
  TXTCLI_Observer,
  TXTCLI_Suspended,
  TXTWCL_Waiting_for_Confirmation
} from './constants.messages.json';

export const PKR_INITIAL_GAMES_DATA: GamesByClubs = {};
export const PKR_INITIAL_TOURNAMENT_DATA: GamesByClubs = {};
export const PKR_LOADERS = {
  userClubs: 'userClubs',
  clubInfo: 'clubInfo',
  userClubsAndGames: 'userClubsAndGames',
  initial: 'initial'
};

export const PKR_INITIAL_STATE: PageData = {
  clubs: [],
  games: {
    tables: [],
    tourns: [],
    recentTourns: [],
    activeGameIds: [],
    selectedGameIds: []
  },
  loading: {
    [PKR_LOADERS.initial]: true
  }
};

export const PKR_ROLE_TRANSLATIONS = {
  [UserClubRole.Manager]: TXTCLI_Manager,
  [UserClubRole.Admin]: TXTCLI_Admin,
  [UserClubRole.Member]: TXTCLI_Member,
  [UserClubRole.Observer]: TXTCLI_Observer,
  [UserClubRole.Guest]: TXTCLI_Guest,
  [UserClubRole.Confirmation]: TXTWCL_Waiting_for_Confirmation,
  [UserClubRole.Suspended]: TXTCLI_Suspended
};

export const PKR_USER_ROLE_TRANSLATIONS = {
  [ClubPlayerRole.FOUNDER]: TXTCLI_Manager,
  [ClubPlayerRole.ADMIN]: TXTCLI_Admin,
  [ClubPlayerRole.MEMBER]: TXTCLI_Member,
  [ClubPlayerRole.OBSERVER]: TXTCLI_Observer,
  [ClubPlayerRole.GUEST]: TXTCLI_Guest,
  [ClubPlayerRole.APPLIED]: TXTWCL_Waiting_for_Confirmation,
  [ClubPlayerRole.SUSPENDED]: TXTCLI_Suspended
};
